import { render, staticRenderFns } from "./EditMatchPopup.vue?vue&type=template&id=be4d31ba&scoped=true"
import script from "./EditMatchPopup.vue?vue&type=script&lang=js"
export * from "./EditMatchPopup.vue?vue&type=script&lang=js"
import style0 from "./EditMatchPopup.vue?vue&type=style&index=0&id=be4d31ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be4d31ba",
  null
  
)

export default component.exports